import { lightColors } from '@/plugins/colors/base/baseColorsLight'
import textTokensLight from '@/plugins/colors/tokens/light/sections/text'

const tooltipTokensLight = {
  'tooltip-background-default': lightColors.gray['900 alfa 75'],
  'tooltip-foreground-default': textTokensLight['text-primary-invert']
}

export default tooltipTokensLight
